import { z } from 'zod';

export const CustomerDtoSchema = z.object({
  customerID: z.coerce.number(),
  name: z.string(),
  isGroup: z.boolean(),
});

export type CustomerDto = z.infer<typeof CustomerDtoSchema>;

export const CustomerListDtoSchema = z.array(CustomerDtoSchema);

export type CustomerListDto = z.infer<typeof CustomerListDtoSchema>;
